(function () {
  'use strict';

  // Strings traducibles inyectados por size-recommender.liquid (window.HS_SR_STRINGS).
  // Si faltan, cada uso cae en el literal español original. Los [placeholders]
  // se reemplazan en runtime.
  const T = window.HS_SR_STRINGS || {};
  function t(k, fb) { const v = T[k]; return (v == null) ? fb : v; }

  // Envuelve un codigo de talla que va incrustado en una frase traducible.
  // La frase se sigue pudiendo traducir; el codigo no (evita "M" -> "METRO").
  function NO_T(code) { return '<span translate="no">' + code + '</span>'; }

  const KEY = 'hs_size_profile';
  const VERSION = '1.0';

  const TABLE = [
    { key: 'XXS', mx: 'XXCH', jeans: 22, bust: [78,81],   waist: [58,61], hip: [86,89]   },
    { key: 'XS',  mx: 'XCH',  jeans: 24, bust: [82,85],   waist: [62,65], hip: [90,93]   },
    { key: 'S',   mx: 'CH',   jeans: 26, bust: [86,89],   waist: [66,69], hip: [94,97]   },
    { key: 'M',   mx: 'M',    jeans: 28, bust: [90,95],   waist: [70,75], hip: [98,103]  },
    { key: 'L',   mx: 'G',    jeans: 30, bust: [96,100],  waist: [76,80], hip: [104,108] },
    { key: 'XL',  mx: 'XG',   jeans: 32, bust: [101,105], waist: [81,85], hip: [109,113] },
    { key: 'XXL', mx: 'XXG',  jeans: 34, bust: null,      waist: [85,89], hip: [112,118] },
    { key: 'ONE_SIZE', mx: 'Unitalla', jeans: null, bust: [82,100], waist: [62,80], hip: [90,108] }
  ];

  const OLD_JEANS = { '24':'XXS','25':'XS','26':'S','27':'M','28':'L','29':'XL','30':'XXL' };
  const NEW_JEANS = { '22':'XXS','24':'XS','26':'S','28':'M','30':'L','32':'XL','34':'XXL' };

  const WEIGHTS = {
    bottom: { bust: 0,    waist: 0.45, hip: 0.35 },
    top:    { bust: 0.50, waist: 0.35, hip: 0.15 },
    dress:  { bust: 0.35, waist: 0.30, hip: 0.25 }
  };

  const ZONE_NAMES = { bust: t('zone_bust', 'busto'), waist: t('zone_waist', 'cintura'), hip: t('zone_hip', 'cadera') };
  const ZONE_JOIN = t('zone_join', ' y ');

  const FIELD_RANGES = {
    bust:   { min: 60,  max: 180 },
    waist:  { min: 50,  max: 150 },
    hip:    { min: 70,  max: 200 },
    height: { min: 130, max: 220 },
    age:    { min: 0,   max: 150, noConvert: true }
  };

  // state
  let _type = 'top';
  let _variantRaw = [];
  let _rec = null;
  let _jeansMap = NEW_JEANS;

  // ── Storage ──────────────────────────────────────────────────────────────

  function loadProfile() {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; }
  }

  function saveProfile(raw, units) {
    const m = normalizeUnits(raw, units);
    const clean = {};
    Object.keys(m).forEach(k => { if (m[k] != null && m[k] !== '') clean[k] = m[k]; });
    const profile = { version: VERSION, updatedAt: new Date().toISOString(), units, measurements: clean };
    localStorage.setItem(KEY, JSON.stringify(profile));
    return profile;
  }

  function deleteProfile() { localStorage.removeItem(KEY); }

  // ── Units ─────────────────────────────────────────────────────────────────

  function normalizeUnits(m, units) {
    if (units !== 'inch') return { ...m };
    const r = { ...m };
    ['bust', 'waist', 'hip', 'height'].forEach(k => {
      if (r[k]) r[k] = Math.round(r[k] * 2.54 * 10) / 10;
    });
    if (r.weight) r.weight = Math.round(r.weight * 0.453592 * 10) / 10;
    return r;
  }

  // ── Key normalization ──────────────────────────────────────────────────────

  function normalizeKey(v) {
    const s = String(v || '').trim().toUpperCase();
    if (_jeansMap[s]) return _jeansMap[s];
    if (['ONE SIZE', 'UNITALLA', 'ONE_SIZE', 'TALLA ÚNICA', 'ÚNICA'].includes(s)) return 'ONE_SIZE';
    return s;
  }

  // ── Scoring ───────────────────────────────────────────────────────────────

  function fitScore(val, range) {
    if (!range || val == null) return null;
    const [min, max] = range;
    if (val >= min && val <= max) return 100;
    if (val > max) { const d = val - max; return d <= 2 ? 70 : d <= 5 ? 40 : 0; }
    const d = min - val; return d <= 2 ? 75 : d <= 5 ? 45 : 5;
  }

  function scoreRow(row, m, type) {
    const w = WEIGHTS[type];
    const checks = ['bust', 'waist', 'hip']
      .map(k => ({ k, range: row[k], w: w[k] }))
      .filter(c => c.w > 0 && m[c.k] != null && c.range != null);
    if (!checks.length) return { score: 0, used: [] };
    const wSum = checks.reduce((a, c) => a + c.w, 0);
    let score = checks.reduce((a, c) => a + (c.w / wSum) * fitScore(m[c.k], c.range), 0);
    return { score: Math.min(100, score), used: checks.map(c => c.k) };
  }

  function scoreXXL(row, m) {
    const checks = [
      { k: 'waist', w: 0.55 },
      { k: 'hip',   w: 0.45 }
    ].filter(c => m[c.k] != null);
    if (!checks.length) return { score: 0, used: [] };
    const wSum = checks.reduce((a, c) => a + c.w, 0);
    const score = checks.reduce((a, c) => a + (c.w / wSum) * fitScore(m[c.k], row[c.k]), 0);
    return { score: Math.min(100, score), used: checks.map(c => c.k) };
  }

  // ── Recommendation ────────────────────────────────────────────────────────

  function checkOneSize(m) {
    const os = TABLE.find(r => r.key === 'ONE_SIZE');
    const checks = ['bust', 'waist', 'hip'].filter(k => m[k] != null);
    if (!checks.length) return { type: 'one_size', fits: true, outOf: [], noData: true };
    const outOf = checks.filter(k => m[k] < os[k][0] || m[k] > os[k][1]);
    return { type: 'one_size', fits: outOf.length === 0, outOf };
  }

  function recommend(m, type, variantRaw) {
    const keys = variantRaw.map(normalizeKey);
    const allOneSize = keys.length > 0 && keys.every(k => k === 'ONE_SIZE');
    if (allOneSize) return checkOneSize(m);

    const hasMeasure = m.bust || m.waist || m.hip;
    if (!hasMeasure) return null;

    const scored = TABLE
      .filter(r => r.key !== 'ONE_SIZE')
      .map(r => ({ ...r, ...(r.key === 'XXL' ? scoreXXL(r, m) : scoreRow(r, m, type)) }))
      .sort((a, b) => b.score - a.score);

    const best = scored[0];
    const second = scored[1];
    const confidence = calcConfidence(best, second, type);
    const inVariants = keys.some(k => k === best.key);
    const alt = second && second.score >= 70 && (best.score - second.score) <= 15 ? second : null;

    return { type: 'size', best, alt, confidence, inVariants };
  }

  function calcConfidence(best, second, type) {
    const needed = { bottom: ['waist','hip'], top: ['bust','waist'], dress: ['bust','waist','hip'] };
    const filled = (best.used || []).filter(k => (needed[type] || []).includes(k)).length;
    const diff = second ? best.score - second.score : 100;
    if (filled >= 2 && best.score >= 85 && diff >= 20) return 'high';
    if (filled >= 1 && best.score >= 60) return 'medium';
    return 'low';
  }

  // ── Render: PDP block ─────────────────────────────────────────────────────

  function renderBlock(rec) {
    const block = document.getElementById('hs-sr-block');
    if (!block) return;

    if (!rec) {
      block.innerHTML = `
        <div class="hs-sr-trigger" id="hs-sr-open" role="button" tabindex="0">
          <svg class="hs-sr-trigger__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="8" width="22" height="8" rx="2"/><line x1="5" y1="8" x2="5" y2="12.5"/><line x1="9" y1="8" x2="9" y2="11"/><line x1="13" y1="8" x2="13" y2="12.5"/><line x1="17" y1="8" x2="17" y2="11"/><line x1="21" y1="8" x2="21" y2="11"/></svg>
          <div class="hs-sr-trigger__text">
            <span class="hs-sr-trigger__title">${t('title', 'Encuentra tu talla')}</span>
          </div>
          <svg class="hs-sr-trigger__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
        </div>`;
      bindOpen();
      return;
    }

    if (rec.type === 'one_size') {
      let msg = '';
      if (rec.noData) {
        msg = t('onesize_nodata_block', 'Ingresa tus medidas para saber si esta prenda es para ti.');
      } else if (rec.fits) {
        msg = t('onesize_fits', 'Tus medidas están dentro del rango. Esta prenda puede funcionarte. ✓');
      } else {
        const zones = rec.outOf.map(k => ZONE_NAMES[k]).join(ZONE_JOIN);
        msg = t('onesize_out', 'Tu [zones] está ligeramente fuera del rango típico.').replace('[zones]', zones);
      }
      block.innerHTML = `
        <div class="hs-sr-rec" id="hs-sr-open" role="button" tabindex="0">
          <div class="hs-sr-rec__top">
            <span class="hs-sr-rec__label">${t('onesize_prefix', 'Esta prenda es Unitalla — [msg]').replace('[msg]', msg)}</span>
            <svg class="hs-sr-trigger__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
          </div>
        </div>`;
      bindOpen();
      return;
    }

    const { best, alt, inVariants } = rec;
    const sizeDisplay = best.key;
    const equivParts = [];
    if (best.jeans) equivParts.push(`Jeans: ${best.jeans}`);

    block.innerHTML = `
      <div class="hs-sr-rec" id="hs-sr-open" role="button" tabindex="0">
        <div class="hs-sr-rec__top">
          <div>
            <span class="hs-sr-rec__label">${t('rec_label', 'Tu talla recomendada')}</span>
            <span class="hs-sr-rec__size" translate="no">${sizeDisplay}</span>
            ${equivParts.length ? `<span class="hs-sr-rec__equiv">${equivParts.join(' · ')}</span>` : ''}
          </div>
          <svg class="hs-sr-trigger__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
        </div>
        ${!inVariants ? `<span class="hs-sr-rec__warn">${t('rec_warn_not_included', 'Esta prenda no incluye [size], pero es tu talla ideal.').replace('[size]', NO_T(best.key))}</span>` : ''}
        ${alt ? `<span class="hs-sr-rec__alt">${t('rec_alt_html', 'También puede quedar bien una <strong>[alt]</strong> si prefieres más holgura.').replace('[alt]', NO_T(alt.key))}</span>` : ''}
      </div>`;
    bindOpen();
  }


  // ── Modal ─────────────────────────────────────────────────────────────────

  function openModal() {
    const modal = document.getElementById('hs-sr-modal');
    if (!modal) return;
    renderModalContent();
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = document.getElementById('hs-sr-modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    const modal = document.getElementById('hs-sr-modal');
    if (!modal) return;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderModalContent() {
    const profile = loadProfile();
    const m = profile?.measurements || {};
    const units = profile?.units || 'cm';
    const content = document.getElementById('hs-sr-modal-body');
    if (!content) return;
    content.innerHTML = buildForm(m, units);
    bindFormEvents();
    if (_rec) showResult(_rec);
    setFooterBtn(_rec ? 'done' : 'submit');
  }

  function buildForm(m, units) {
    const u = units === 'inch' ? 'inch' : 'cm';
    const wu = units === 'inch' ? 'lbs' : 'kg';
    return `
      <div class="hs-sr-units" role="group" aria-label="${t('units_aria', 'Unidades de medida')}">
        <button type="button" class="hs-sr-units__btn${units !== 'inch' ? ' active' : ''}" data-units="cm">cm / kg</button>
        <button type="button" class="hs-sr-units__btn${units === 'inch' ? ' active' : ''}" data-units="inch">inch / lbs</button>
      </div>
      <p class="hs-sr-section__title">${t('my_measurements', 'Mis medidas')}</p>
      ${numField('bust',  t('field_bust', 'Busto / pecho'), m.bust,  u)}
      ${numField('waist', t('field_waist', 'Cintura'),       m.waist, u)}
      ${numField('hip',   t('field_hip', 'Cadera'),        m.hip,   u)}
      <div class="hs-sr-row">
        ${selField('bra_band', t('field_bra_band', 'Sujetador'), m.bra_band, ['','28','30','32','34','36','38','40','42','44'])}
        ${selField('bra_cup',  t('field_bra_cup', 'Copa'),      m.bra_cup,  ['','A','B','C','D','E','F','G'])}
      </div>
      <details class="hs-sr-optional">
        <summary class="hs-sr-optional__toggle">${t('optional_toggle', '+ Agregar otras medidas')} <small>${t('optional_hint', '(opcional, mejora la precisión)')}</small></summary>
        <div class="hs-sr-optional__body">
          ${numField('height', t('field_height', 'Altura'), m.height, u)}
          ${numField('weight', t('field_weight', 'Peso'),   m.weight, wu)}
          ${numField('age',    t('field_age', 'Edad'),   m.age,    t('unit_age', 'años'))}
        </div>
      </details>
      ${m.bust || m.waist ? `<button type="button" class="hs-sr-delete-btn" id="hs-sr-delete">${t('delete_btn', 'Borrar mis medidas')}</button>` : ''}
      <div id="hs-sr-form-error" class="hs-sr-form-error" style="display:none;"></div>
      <div id="hs-sr-result" class="hs-sr-result" style="display:none;"></div>
    `;
  }

  function numField(id, label, val, unit) {
    return `
      <div class="hs-sr-field">
        <label class="hs-sr-field__label" for="hs-${id}">${label}</label>
        <div class="hs-sr-field__wrap">
          <input class="hs-sr-field__input" type="number" id="hs-${id}" name="${id}" value="${val || ''}" min="1" step="0.1" inputmode="decimal">
          <span class="hs-sr-field__unit">${unit}</span>
        </div>
        ${FIELD_RANGES[id] ? `<span class="hs-sr-field__error" id="hs-err-${id}"></span>` : ''}
      </div>`;
  }

  function validateForm(units) {
    let valid = true;
    Object.entries(FIELD_RANGES).forEach(([id, range]) => {
      const input = document.getElementById(`hs-${id}`);
      const errEl = document.getElementById(`hs-err-${id}`);
      if (!input || !errEl || input.value === '') { if (errEl) errEl.textContent = ''; return; }
      const val = parseFloat(input.value);
      let min = range.min, max = range.max;
      if (units === 'inch' && !range.noConvert) {
        min = Math.floor(min / 2.54 * 10) / 10;
        max = Math.ceil(max / 2.54 * 10) / 10;
      }
      if (isNaN(val) || val < min || val > max) {
        const u = range.noConvert ? '' : ` ${units === 'inch' ? 'inch' : 'cm'}`;
        errEl.textContent = t('err_range', 'Ingresa un valor entre [min] y [max][unit]')
          .replace('[min]', min).replace('[max]', max).replace('[unit]', u);
        valid = false;
      } else {
        errEl.textContent = '';
      }
    });
    return valid;
  }

  function selField(id, label, val, opts, isNum) {
    const options = opts.map(o => {
      const sel = o !== '' && (isNum ? Number(val) === Number(o) : val == o) ? ' selected' : '';
      return `<option value="${o}"${sel}>${o || t('select_placeholder', 'Seleccionar')}</option>`;
    }).join('');
    return `
      <div class="hs-sr-field">
        <label class="hs-sr-field__label" for="hs-${id}">${label}</label>
        <select class="hs-sr-field__select" id="hs-${id}" name="${id}">${options}</select>
      </div>`;
  }

  function collectValues() {
    const raw = {};
    ['bust','waist','hip','height','weight','age'].forEach(k => {
      const el = document.getElementById(`hs-${k}`);
      if (el && el.value !== '') raw[k] = parseFloat(el.value);
    });
    ['bra_band','bra_cup'].forEach(k => {
      const el = document.getElementById(`hs-${k}`);
      if (el && el.value) raw[k] = el.value;
    });
    return raw;
  }

  function showResult(rec) {
    const result = document.getElementById('hs-sr-result');
    if (!result) return;

    let html = '';
    if (!rec) {
      html = `<p class="hs-sr-result__error">${t('result_error', 'No pudimos calcular una recomendación. Intenta agregar más medidas.')}</p>`;
    } else if (rec.type === 'one_size') {
      const msg = rec.noData
        ? t('result_onesize_nodata', 'No hay medidas suficientes para verificar el ajuste.')
        : rec.fits
          ? t('onesize_fits', 'Tus medidas están dentro del rango. Esta prenda puede funcionarte. ✓')
          : t('onesize_out', 'Tu [zones] está ligeramente fuera del rango típico.').replace('[zones]', rec.outOf.map(k => ZONE_NAMES[k]).join(ZONE_JOIN));
      html = `<div class="hs-sr-result__box"><p class="hs-sr-result__check">${t('result_onesize_title', 'Esta prenda es Unitalla')}</p><p class="hs-sr-result__sub">${msg}</p></div>`;
    } else {
      const { best, alt, inVariants } = rec;
      const sizeDisplay = best.key;
      const equivParts = [];
      if (best.jeans) equivParts.push(`Jeans: ${best.jeans}`);
      const basedOn = (best.used || []).map(k => ZONE_NAMES[k]).join(ZONE_JOIN);
      html = `
        <div class="hs-sr-result__box">
          <p class="hs-sr-result__check">${t('result_check', '✓ Te recomendamos talla')}</p>
          <p class="hs-sr-result__size" translate="no">${sizeDisplay}</p>
          ${equivParts.length ? `<p class="hs-sr-result__sub">${equivParts.join(' · ')}</p>` : ''}
          ${basedOn ? `<p class="hs-sr-result__based">${t('result_based', 'Basado en: [based].').replace('[based]', basedOn)}</p>` : ''}
          ${alt ? `<p class="hs-sr-result__alt">${t('rec_alt_html', 'También puede quedar bien una <strong>[alt]</strong> si prefieres más holgura.').replace('[alt]', NO_T(alt.key))}</p>` : ''}
          ${!inVariants ? `<p class="hs-sr-result__warn">${t('result_warn_not_included', 'Esta prenda no incluye [size], pero es la talla que mejor coincide con tus medidas.').replace('[size]', NO_T(best.key))}</p>` : ''}
        </div>`;
    }

    result.innerHTML = html;
    result.style.display = 'block';
    result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function setFooterBtn(mode) {
    const btn = document.getElementById('hs-sr-submit');
    if (!btn) return;
    if (mode === 'done') {
      btn.textContent = t('done', 'Listo, ya sé mi talla');
      btn.onclick = closeModal;
    } else {
      btn.textContent = t('submit', 'Ver mi talla recomendada');
      btn.onclick = handleSubmit;
    }
  }

  function handleSubmit() {
    const raw = collectValues();
    const units = document.querySelector('.hs-sr-units__btn.active')?.dataset?.units || 'cm';
    const hasMeasure = raw.bust || raw.waist || raw.hip;
    if (!hasMeasure) {
      const err = document.getElementById('hs-sr-form-error');
      if (err) { err.textContent = t('err_no_measure', 'Ingresa al menos una medida para continuar.'); err.style.display = 'block'; }
      return;
    }
    if (!validateForm(units)) return;
    const profile = saveProfile(raw, units);
    _rec = recommend(profile.measurements, _type, _variantRaw);
    renderBlock(_rec);
    showResult(_rec);
    setFooterBtn('done');
  }

  function bindFormEvents() {
    document.querySelectorAll('.hs-sr-units__btn').forEach(btn => {
      btn.addEventListener('click', function () {
        const profile = loadProfile();
        const m = profile?.measurements || {};
        const content = document.getElementById('hs-sr-modal-body');
        if (content) { content.innerHTML = buildForm(m, this.dataset.units); bindFormEvents(); if (_rec) showResult(_rec); }
      });
    });

    document.getElementById('hs-sr-delete')?.addEventListener('click', () => {
      deleteProfile(); _rec = null;
      renderBlock(null);
      const fit = document.getElementById('hs-sr-fit');
      if (fit) fit.style.display = 'none';
      closeModal();
    });
  }

  function bindOpen() {
    const btn = document.getElementById('hs-sr-open');
    if (!btn) return;
    btn.addEventListener('click', openModal);
    btn.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(); } });

  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    const block = document.getElementById('hs-sr-block');
    if (!block) return;

    _type = block.dataset.type || 'top';
    _variantRaw = (block.dataset.variants || '').split(',').map(s => s.trim()).filter(Boolean);

    // Detect old vs new jeans mapping
    const hasOldStyle = _variantRaw.some(v => ['25','27','29'].includes(v.trim()));
    _jeansMap = hasOldStyle ? OLD_JEANS : NEW_JEANS;

    const profile = loadProfile();
    if (profile?.measurements) {
      _rec = recommend(profile.measurements, _type, _variantRaw);
    }

    renderBlock(_rec);

    // Modal overlay + close
    document.getElementById('hs-sr-overlay')?.addEventListener('click', closeModal);
    document.getElementById('hs-sr-modal-close')?.addEventListener('click', closeModal);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

    // Submit button (sticky footer) — initial binding; state managed by setFooterBtn()
    const submitBtn = document.getElementById('hs-sr-submit');
    if (submitBtn) submitBtn.onclick = handleSubmit;

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
